module.exports = __webpack_public_path__ + "wxMicroService/img/head-bg.72f9a5b7.gif";